import { render, staticRenderFns } from "./EditAsf.vue?vue&type=template&id=45444bc2"
import script from "./EditAsf.vue?vue&type=script&lang=js"
export * from "./EditAsf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports